function tableOfContents() {
  let headlines = document.querySelectorAll('h2');
  let tocContent = document.querySelector('[data-table-of-contents]');
  let tocContainer = document.querySelector('.toc-container');
  let w = window.innerWidth;


  var slug = function(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
  
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
             .replace(/\s+/g, '-') // collapse whitespace and replace by -
             .replace(/-+/g, '-'); // collapse dashes

    if (/^\d/.test(str)) {   // ids need to start with a letter, if they start with a number it doesnt work
      str = 'd' + str;
    }
  
    return str;
  };

  headlines.forEach((headline) => {
    if (headline.id === "") {
      headline.id = slug(headline.textContent || headline.innerText || "");
    }
  });

  if (w < 1100) {
    tocContainer.style.display = 'none';
    tocContainer.parentNode.style.display = 'none';
  }

  function returnContents() {
    if (headlines.length !== 0 ) {
      for (let i = 0; i < headlines.length; i++) {
        tocContent.innerHTML +=
          "<a href='#" +
          headlines[i].id +
          "'>" +
          headlines[i].innerText +
          '</a>';
      }
    } else {
        tocContainer.style.display = 'none';
    }
  }

  function  positionClassCreator() {
    let currentScrollY = window.pageYOffset;
    let imageHeader = document.querySelector(".page-header");
    let imageHeaderHeight = imageHeader.clientHeight + 300;
    let tableOfContents = document.querySelector(".toc");
    let tableHeight = tableOfContents.offsetHeight;
    let postContainer = document.querySelector(".page-main > .row-content");
    let postContainerBottom = postContainer.getBoundingClientRect().bottom;

    if (postContainerBottom <= tableHeight + 160) {
      tableOfContents.classList.remove("sticky");
      tableOfContents.classList.add("parked");
      
      return "parked"; 
    }

    if (currentScrollY >= imageHeaderHeight) {
      tableOfContents.classList.remove("parked");
      tableOfContents.classList.add("sticky");
      return "sticky";
    }

    if (currentScrollY < imageHeaderHeight) {
      tableOfContents.classList.remove("parked");
      tableOfContents.classList.remove("sticky");
      
    } 
  }

  function onScroll(){
    
    let tableOfContents = document.querySelector('.toc');

    if (!tableOfContents) {
      return;
    }

    let tableOfContentsLinks = tableOfContents.querySelectorAll('a');

    for (let i = 0; i < tableOfContentsLinks.length; i++) {
      let currentLink = tableOfContentsLinks[i];

      let href = currentLink.getAttribute('href');
      href = href.replace('#', '');

      let refElement = document.getElementById(href);

      if (!refElement || !refElement.getBoundingClientRect()) {
        continue;
      }
      
      if (refElement.getBoundingClientRect().top <= 300) {
        removeClassBySelector('.toc .content a', '-active');
        currentLink.classList.add('-active');
      } else {
        currentLink.classList.remove('-active');
      }
    }
    
    function removeClassBySelector(selector, className) {
      let nodes = document.querySelectorAll(selector);
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].classList.remove(className);
      }
    }
  }

  returnContents();

  window.addEventListener('scroll', positionClassCreator); 
  window.addEventListener('scroll', onScroll);

}

document.addEventListener('load', tableOfContents());
